module.exports = __webpack_public_path__ + "img/材料力学1_7.04704353.jpg";